import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

const SAModalConfirm = (props) => {

    const [showMode, setShowModel] = useState("")
    useEffect(() =>{
        setShowModel("")
    },[props])

    const submitModal = () => {
        if (props?.handleOk) {
            props.handleOk();
        }
        setShowModel(false)
    };

    const cancelModal = () => {
        if (props?.handleCancel) {
            props.handleCancel();
        }
        setShowModel(false)
    };

    // Handle z-index for modal and backdrop when showing
    useEffect(() => {
        const zIndex = props?.zIndex || 2100; // Higher than Agent Apps modal (2000)
        const isShowing = props?.show || showMode !== "";
        
        if (isShowing) {
            // Function to update z-index for both backdrop and modal-dialog
            const updateZIndex = () => {
                // Find all modal elements with restore-modal class (this modal)
                const modalElements = document.querySelectorAll('.modal.restore-modal');
                if (modalElements.length > 0) {
                    // Get the last one (most recent)
                    const modalElement = modalElements[modalElements.length - 1];
                    
                    // Set z-index on modal element with !important
                    modalElement.style.setProperty('z-index', `${zIndex + 1}`, 'important');
                    
                    // Find and set z-index on modal-dialog
                    const modalDialog = modalElement.querySelector('.modal-dialog');
                    if (modalDialog) {
                        modalDialog.style.setProperty('z-index', `${zIndex + 1}`, 'important');
                    }
                    
                    // Also set on modal-content for extra safety
                    const modalContent = modalElement.querySelector('.modal-content');
                    if (modalContent) {
                        modalContent.style.setProperty('z-index', `${zIndex + 1}`, 'important');
                    }
                }
                
            // Set z-index for modal backdrop (Bootstrap creates this automatically)
                const backdrops = document.querySelectorAll('.modal-backdrop');
                if (backdrops.length > 0) {
                    // Set the last backdrop (most recent modal) to have the correct z-index
                    const lastBackdrop = backdrops[backdrops.length - 1];
                    lastBackdrop.style.setProperty('z-index', `${zIndex}`, 'important');
                }
            };
            
            // Update immediately and also after delays to catch Bootstrap's DOM manipulation
            updateZIndex();
            const timeoutId1 = setTimeout(updateZIndex, 10);
            const timeoutId2 = setTimeout(updateZIndex, 50);
            const timeoutId3 = setTimeout(updateZIndex, 100);
            const timeoutId4 = setTimeout(updateZIndex, 200);
            
            // Also listen for DOM mutations to catch Bootstrap's backdrop creation
            let mutationTimeout;
            const observer = new MutationObserver(() => {
                if (mutationTimeout) clearTimeout(mutationTimeout);
                mutationTimeout = setTimeout(updateZIndex, 10);
            });
            observer.observe(document.body, {
                childList: true,
                subtree: false, // Only observe direct children of body for better performance
                attributes: false
            });
            
            return () => {
                clearTimeout(timeoutId1);
                clearTimeout(timeoutId2);
                clearTimeout(timeoutId3);
                clearTimeout(timeoutId4);
                if (mutationTimeout) clearTimeout(mutationTimeout);
                observer.disconnect();
            };
        }
    }, [props?.show, showMode, props?.zIndex]);

    const zIndex = props?.zIndex || 2100; // Higher than Agent Apps modal (2000)

    return (
        <Modal 
            className="restore-modal" 
            centered={props?.centered ? props?.centered : false} 
            show={showMode !== "" ? showMode : props?.show}
            style={{ zIndex: zIndex + 1 }}
        >

                {props?.title && <Modal.Title className="text-center pt-3">{props?.title}</Modal.Title>}

                <Modal.Body className="text-center">
                    <p>{props?.message}</p>
                </Modal.Body>

                <Modal.Footer className="flex-nowrap p-0 border-top">
                    <Button
                        variant="link"
                        size="lg"
                        onClick={()=> cancelModal()}
                        className="fs-6 text-decoration-none col-6 py-3 m-0 rounded-0 rounded-0 border-end"
                    >
                        <b>{props?.cancelText ? props?.cancelText : "No"}</b>
                    </Button>
                    <Button
                        variant="link"
                        size="lg"
                        className="fs-6 text-decoration-none col-6 py-3 m-0 "
                        onClick={()=> submitModal()}
                    >
                        <b>{props?.okText ? props?.okText : "Yes"}</b>
                    </Button>
                </Modal.Footer>
        </Modal>
    );
};

export default SAModalConfirm;
